import { render, staticRenderFns } from "./ReportAccountPayment.vue?vue&type=template&id=80874afc"
import script from "./ReportAccountPayment.vue?vue&type=script&lang=js"
export * from "./ReportAccountPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports